export const licenseMapper = code => {
    if (['CC CC0', 'CC CC0 1.0'].includes(code)) {
        return ['CC CC0'];
    }

    return [code];
};
